<mat-form-field appearance="outline">
  <mat-label>{{label}}</mat-label>
  <input matInput type={{type}} placeholder={{placeholder}} [formControl]="$any(ngControl?.control)"
    (input)="onInput($event)">
  <mat-icon matSuffix>{{icon}}</mat-icon>
  @if (ngControl?.control?.hasError('required')) {
  <mat-error>
    {{ 'ERROR.PLEASE_ENTER' | transloco }} {{label}}
  </mat-error>
  }
  @if (ngControl?.control?.hasError('touched')) {
  <mat-error>
    {{ 'ERROR.PLEASE_ENTER' | transloco }} {{label}}
  </mat-error>
  }
  @if (ngControl?.control?.hasError('minlength')) {
  <mat-error>
    {{ 'ERROR.MIN_LENGTH_6' | transloco }}
  </mat-error>
  }
  @if (ngControl?.control?.hasError('email')) {
  <mat-error>
    {{ 'ERROR.PLEASE_ENTER' | transloco }} {{ 'ERROR.EMAIL' | transloco }}
  </mat-error>
  }
  @if (ngControl?.control?.hasError('qualityXpoBookingNumber')) {
  <mat-error>
    {{"PARKIFLY.ERROR.QUALITY_XPO_BOOKING_NUMBER" | transloco}}
  </mat-error>
  }
</mat-form-field>